import { tenantRouterModel } from 'APP/model/model';
import {
  IDiscoverDestination,
  ITenantRouterUrls,
} from 'APP/model/tenantRouter/tenantRouterModel.types';
import { storage } from 'APP/packages/storage';

export async function updateDestinationBaseUrl(
  destination: IDiscoverDestination
): Promise<boolean> {
  try {
    const bffUrl = await tenantRouterModel.updateDestinationBaseUrl(destination);
    if (!bffUrl) {
      storage.tenantRouting.remove();
      return false;
    }

    storage.tenantRouting.set({
      ...(storage.tenantRouting.get() || ({} as ITenantRouterUrls)),
      bffUrl,
    });

    return true;
  } catch {
    storage.tenantRouting.remove();
    return false;
  }
}
